import types from '../mutation-types';
import SocialCommentsAPI from '../../api/socialComments';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
  currentPage: 1,
  totalCount: 0,
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getComments(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return {
      count: _state.totalCount,
      currentPage: _state.currentPage,
      hasMore: _state.records.length < _state.totalCount,
    };
  },
};

export const actions = {
  get: async ({ commit }, { socialPostId, page = 1, status }) => {
    commit(types.SET_SOCIAL_COMMENTS_UI_FLAG, { isFetching: true });
    try {
      const params = { page, status };
      const response = await SocialCommentsAPI.getByPost(socialPostId, params);
      const { payload, meta } = response.data;
      if (page === 1) {
        commit(types.SET_SOCIAL_COMMENTS, payload);
      } else {
        commit(types.APPEND_SOCIAL_COMMENTS, payload);
      }
      commit(types.SET_SOCIAL_COMMENTS_META, meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SOCIAL_COMMENTS_UI_FLAG, { isFetching: false });
    }
  },
  reply: async (_, { id, content }) => {
    return SocialCommentsAPI.reply(id, content);
  },
  like: async (_, { id }) => {
    return SocialCommentsAPI.like(id);
  },
  hide: async (_, { id }) => {
    return SocialCommentsAPI.hide(id);
  },
  openDm: async (_, { id, message }) => {
    return SocialCommentsAPI.openDm(id, message);
  },
  delete: async (_, { id }) => {
    return SocialCommentsAPI.delete(id);
  },
  addFromCable: ({ commit, state: _state }, { comment, post }) => {
    // Only add if we're currently viewing this post's comments
    if (
      _state.records.length &&
      _state.records[0]?.social_post_id !== post.id
    ) {
      return;
    }
    // Avoid duplicates
    if (_state.records.some(c => c.id === comment.id)) return;
    commit(types.ADD_SOCIAL_COMMENT, comment);
  },
  clearComments: ({ commit }) => {
    commit(types.SET_SOCIAL_COMMENTS, []);
    commit(types.SET_SOCIAL_COMMENTS_META, { count: 0, current_page: 1 });
  },
};

export const mutations = {
  [types.SET_SOCIAL_COMMENTS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_SOCIAL_COMMENTS](_state, data) {
    _state.records = data;
  },
  [types.APPEND_SOCIAL_COMMENTS](_state, data) {
    _state.records = [..._state.records, ...data];
  },
  [types.SET_SOCIAL_COMMENTS_META](_state, meta) {
    _state.totalCount = meta.count;
    _state.currentPage = meta.current_page;
  },
  [types.ADD_SOCIAL_COMMENT](_state, comment) {
    _state.records = [comment, ..._state.records];
    _state.totalCount += 1;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
